import React, {useImperativeHandle} from 'react'
import {Grid} from "semantic-ui-react"
import DropDown from "../../../components/commonComponents/formComponents/dropDown";
import InputField from '../../../components/commonComponents/formComponents/inputField';
import Box40Mock from './Box40Mock';
import Box44Mock from './Box44Mock';
import PDCMock from './PDCMock';
import ErrorMock from './ErrorMock';
import { responseCodes, circuitVal } from './mockConstants';

const CommonFieldsMock = ({reference, propMRN, formType}) => {
    const PDCreference = React.useRef(null);
    const BOX40reference = React.useRef(null);
    const BOX44reference = React.useRef(null);
    const errorReference = React.useRef(null);
    const [responseCode, setResp] = React.useState("0");
    const [circuit, setCircuit] = React.useState("");
    const [MRN, setMRN] = React.useState(propMRN ? propMRN : "");
    useImperativeHandle(reference, () => ({
        getUpdateResponseData: () => {
            return {common: {responseCode, circuit, MRN},box44: BOX44reference.current?.getBox44Data(), box40: BOX40reference.current?.getBox40Data(), PDC: PDCreference.current?.getPDCData(),
            error: errorReference.current?.getErrorData()
        }
        },
    }));
    return ( 
        <Grid>
            <Grid.Row className="entry-number-row">
                {formType !== "Cancel" && <Grid.Column width={5}>
                    <DropDown 
                        style={{"borderColor": "#1765AE"}}
                        type="text"
                        id='ResponseCode'
                        label="Response Code"
                        className="status-dropdown field-bg dropdown100"
                        data={responseCodes}
                        value={responseCode === -1 ? "SELECT" : responseCode}
                        onChange={(value) => setResp(value)}
                    />
                </Grid.Column>}
                {responseCode === "0" && <>
                {formType !== "Cancel" && formType !== "PDC" && <Grid.Column width={5}>
                    <DropDown 
                        style={{"borderColor": "#1765AE"}}
                        type="text"
                        id='Circuit'
                        label="Circuit"
                        className="status-dropdown field-bg dropdown100"
                        data={circuitVal}
                        value={circuit === "" ? "SELECT" : circuit}
                        onChange={(value) => setCircuit(value)}
                    />
                </Grid.Column>}
                <Grid.Column width={6} className={`row-ur-mrn`}>
                    <InputField
                        isLabel={false}
                        id="ur-mrn"
                        className={'field-bg ur-mrn'}
                        label="MRN"
                        disabled={formType === "Cancel" && responseCode === "9"}
                        value={MRN}
                        onChange={(value) => setMRN(value)}
                    />
                </Grid.Column>
                </>}
            </Grid.Row>
            {responseCode === "0" && <>
                {(formType === "PDC" || formType === "PdcAmend" || formType === "FullSad") && <Grid.Row className="entry-number-row">
                    <PDCMock ref={PDCreference} formType={formType} />
                </Grid.Row>}
                {formType === "Box44" && <Box44Mock ref={BOX44reference} />}
                {(formType === "Box40" || formType === "PdcAmend") && <Box40Mock ref={BOX40reference} />}
            </>}
            {(responseCode === "9" && formType !== "Cancel") && <ErrorMock ref={errorReference} />}

        </Grid>
     );
}
 
export default CommonFieldsMock;